// 簽到退編輯紀錄
import * as types from '../actionType';

let initState = []

function SignInOutHistoryState(state = initState, action) {
  switch (action.type) {
      case types.GET_SIGNINOUT_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default SignInOutHistoryState;